import _isEmpty from 'lodash/isEmpty';
import { eventDetailsService, productCatalogService } from 'config/api';
import { addNotification } from 'modules/shell/actions';
import { hasNBACriteria, hasRecommendedProductsCriteria, getRTCItemWithRecommendedProducts } from 'utils';
import actionTypes from './actionTypes';

export const getEventDetails = (associateId) => async (dispatch) => {
  dispatch({ type: actionTypes.REASON_TO_CONTACT_LOADING });

  try {
    const res = await eventDetailsService.get(`/rtc/${associateId}`);

    dispatch({
      type: actionTypes.REASON_TO_CONTACT_SUCCESS,
      payload: { ...res.data },
    });
  } catch (error) {
    dispatch({
      type: actionTypes.REASON_TO_CONTACT_ERROR,
      payload: error,
    });
  }
};

const pageSize = 8;
const sortBy = 'bestRecommended';

const getRecommendedProducts = async (criteria) => {
  const promises = criteria.map(
    ({ divisionId, classId, brandName, groupId, departmentId, className, hierarchyLevel1 }) => {
      const params = {};

      if (divisionId) {
        params.divisionId = divisionId;
      }

      if (classId) {
        params.classId = classId;
      }

      if (brandName) {
        params.brands = [brandName];
      }

      if (groupId) {
        params.groupId = groupId;
      }

      if (departmentId) {
        params.departmentId = departmentId;
      }

      if (className) {
        params.className = className;
      }

      if (hierarchyLevel1) {
        params.hierarchyLevel1 = hierarchyLevel1;
      }

      if (_isEmpty(params)) {
        return null;
      }

      return productCatalogService.post('v5/product', { ...params, pageSize, sortBy });
    },
  );

  const results = await Promise.all(promises);

  const data = results.map((result) => {
    if (result) {
      const {
        data: { list },
      } = result;
      return list;
    }

    return null;
  });

  return data;
};

const getReasonItem = async (state, associateId, timestamp) => {
  const { data = [] } = state?.clientsModule?.reasonToContact || {};

  const reasonItem = data.find((reason) => reason.associatePin === associateId && reason.timestamp === timestamp);

  if (reasonItem) {
    return reasonItem;
  }

  const res = await eventDetailsService.post('/rtcDetails', {
    associateId,
    timestamp,
  });

  return res.data;
};

export const getSingleEventDetails = (associateId, timestamp) => async (dispatch, getState) => {
  dispatch({ type: actionTypes.REASON_TO_CONTACT_LOADING });

  try {
    const reasonItem = await getReasonItem(getState(), associateId, timestamp);
    const critetia = [];

    if (hasNBACriteria(reasonItem)) {
      critetia.push(reasonItem.nba);
    }

    if (hasRecommendedProductsCriteria(reasonItem)) {
      critetia.push(...reasonItem.recommendedProducts);
    }

    const recommendedProducts = await getRecommendedProducts(critetia);

    const rtcItem = getRTCItemWithRecommendedProducts(reasonItem, recommendedProducts);

    dispatch({
      type: actionTypes.REASON_TO_CONTACT_SINGLE_SUCCESS,
      payload: { ...rtcItem },
    });
  } catch (error) {
    dispatch({
      type: actionTypes.REASON_TO_CONTACT_ERROR,
      payload: error,
    });
  }
};

export const updateEventAction = (action) => async (dispatch) => {
  try {
    const { associateId } = action;

    const response = await eventDetailsService.post(`/rtc/${associateId}/action`, action);

    dispatch({
      type: actionTypes.REASON_TO_CONTACT_SET_COMPLETED_SUCCESS,
      payload: response,
    });

    return response;
  } catch (error) {
    dispatch(
      addNotification({
        id: `error-${Date.now()}`,
        message: error.message,
        type: 'error',
      }),
    );

    return error;
  }
};

export const restoreReasonToContactCategory = (categoriesState) => ({
  type: actionTypes.REASON_TO_CONTACT_RESTORE,
  payload: categoriesState,
});
